
<div class="_dialog-title">
	<div class="order-ticket-diner mr-2">
		<div class="order-ticket-diner-icon" [style.background]="data.background">
			{{ data.initials }}
		</div>
	</div>
	<div class="flex-grow-1">{{data.name}}</div>
	<button mat-icon-button mat-dialog-close color="accent">
		<mat-icon>close</mat-icon>
	</button>
</div>




<div class="_dialog-content" style="min-height: 170px; min-width: 80vw; max-height: calc(100vh - 150px);">

	@if ( data.pending){
		<div class="alt-panel warning mb-3" style="font-size: 0.9em">
			<div class="alt-panel-body pb-1 ">
				<b style="font-size: 1.1em; margin-bottom: 0.5rem; ">
					{{ 'OAT.offers_pending_approval' | translate }}
				</b>
				@for (item of data.pending.pendingOffers; track item._id; let last = $last) {
					<div class="basket-summary-row" [class.border-bottom]="!last" style="padding: 12px 0;">
						<div class="_title"><div>{{ item.name }}</div></div>
						<div class="_price" style="min-width: 50px; text-align: end; margin-inline-start: 5px;">{{ item.amount | lamount }}</div>
					</div>
				}
				@if (data.pending.isTabOwner) {
					<div class="d-flex justify-content-between mt-2 pb-2">
						<div></div>
						<button matButton="outlined" color="accent" (click)="apply('approveSome')">
							<mat-icon svgIcon="pen"></mat-icon>
							{{ 'OAT.offers_approve-decline' | translate }}
						</button>
					</div>
				}

			</div>
		</div>
	}

	<table class="table">
		<tr>
			<th class="w-100">{{'TO.total-items' | translate}}</th>
			<th class="no-wrap">{{data.totalItems | lamount}}</th>
		</tr>
		<tr><td colspan="2"><hr style="margin: 0.7rem 0"/></td></tr>
		@for (offer of data.offers; track offer ) {
		<tr>
			<td class="w-100">{{offer.name}}</td>
			<td class="no-wrap">{{offer.amount | lamount}}</td>
		</tr>
		}
	</table>
</div>

<div class="_bottom-actions border-top" *ngIf="data.$$balanceDue">

	<button mat-raised-button color="accent" class="lg main-continue-btn mt-2" type="button" (click)="apply('partial')" style="min-width:240px">
		<div class="_inner" style="justify-content:center">
			<div>{{'pay' | translate}}</div>
		</div>
	</button>

</div>
